// Careers page entry point

import { initSwiperCareersWithResize } from './swiper-careers.js';
import { initDeptGrouping } from './dept-grouping.js';

// ─── Swipers ──────────────────────────────────────────────────────────────────

initSwiperCareersWithResize();

// ─── Department Grouping ──────────────────────────────────────────────────────

initDeptGrouping();
